import Route from '@ember/routing/route';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';

import type MetricMoverService from 'webapp/services/metric-mover';

// Target of the Push API email's "Review metrics" link. The link goes through
// /change/space/:space_id, so this already runs in the email's account.
export default class LegacyMetricMigrationReviewRoute extends Route {
	@service('metric-mover') declare metricMoverService: MetricMoverService;
	@service('navigation') declare navigationService: Service.Navigation;

	override async beforeModel(): Promise<void> {
		// the account's deletion dates and sources come with the initial requests
		await this.navigationService.initialRequestsPromise;

		if (this.metricMoverService.openLegacyPushMetricReview()) {
			this.navigationService.transitionToRoute('datamanager');
		} else {
			this.navigationService.transitionToRoute('index');
		}
	}
}
